<template>
<v-dialog
    lazy
    v-model="isShow"
    max-width="400"
    @keydown.esc="cancel"
    :persistent="true"
    content-class="custom-dialog didi-dialog"
  >
    <v-card>
      <v-toolbar color="#E0E0E0" dense flat>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon dark flat @click="toGrabOrClose(4)">
            <v-icon color="#E0E0E0">close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <p class="custom-icon"><img :src="icon" /></p>
      
      <v-card-text class="blue-title text-center">{{ tips }}</v-card-text>
      <div class="custom-footer">
        <v-btn color="#FF9991" class="text-none confirm-button" @click.native="toGrabOrClose(3)" :disabled="submitting" round>{{ submitting ? 'Loading...':'Grab it now'}}</v-btn>
      </div>
    </v-card>
  </v-dialog>

</template>
<script>

import { addTeacheDidiPoint, readTeacheDidiMessage } from '../api/message'
import { GetTutorAccount } from '@/api/classtable.js'
import { getTimestamp } from '@/api/system.js'


import { mapGetters } from 'vuex'
import icon from '@/assets/img/common/didi-icon.png'
import videoSrc from  '@/assets/audio/didi.mp3'
import { encryption } from '@/utils/encryption'
export default {
    data:()=>({
        icon,
        isShow:false,
        tips:'You have a new class request.',
        submitting: false,
        videoSrc: videoSrc

    }),
    mounted(){
        // if(this.didiMsg.dialog){
        //     this.isShow = true
        // }
    },
    methods:{

        async toGrabOrClose(flag){
            // flag : 3点击跳转 4关闭弹窗
            this.submitting = true
            let res = await this.toRead(this.didiMsg.id, this.didiMsg.classID, flag)
            if(res.ErrorCode !== 0){
                console.log('toRead  -  '+ res.Msg);
                this.submitting = false
                return
            }
            this.isShow = false
            this.submitting = false
            if(flag === 3){
                let email
                let params
                if(!this.$store.state.user.account){
                    email = await GetTutorAccount().then(res => {
                        return res
                    })
                    // window.open(`https://kolify.com/admin/grab-orders?email=${email}&nick_name=${this.$store.state.user.fullName}&tuid=${this.$store.state.user.tuid}`)
                }else{
                    email = this.$store.state.user.account
                    // window.open(`https://kolify.com/admin/grab-orders?email=${this.$store.state.user.account}&nick_name=${this.$store.state.user.fullName}&tuid=${this.$store.state.user.tuid}`)
                }
                let n_timestamp = await getTimestamp().then(res => {
                    return res.data.Body.Timestamp || null
                })
                params = `email=${email}&nick_name=${this.$store.state.user.fullName}&tuid=${this.$store.state.user.tuid}&timestamp=${n_timestamp}`
                window.open(`https://kolify.com/admin/grab-orders?${params}&token=${encryption(params)}`)

            }

        },
        async toRead(id, classID, flag){
            // flag : 3点击跳转 4关闭弹窗
            let param={
                ID: id,
                ClassID:classID,
                PointType: flag
            }
            return readTeacheDidiMessage(param).then(res => {
                return res.data
            })
            

        },
        addTeacheDidiPoint(classID, flag){
            let param = {
                ClassID: classID,
                PointType: flag
            }
            addTeacheDidiPoint(param).then(res => {
                if (res.data.ErrorCode !== 0) {
                    console.log('DidiPoint  -  '+ res.data.Msg);
                }
            })
        }
    },
    computed:{
        ...mapGetters([
            'didiMsg'
        ])
    },
    watch:{
        'didiMsg':function(value){
            this.isShow = value.dialog
            if(value.dialog){
                const audio = new Audio(videoSrc);
                audio.play().catch((error) => {
                    console.error('播放失败:', error);
                });
            }
            if(value.dialog && value.isPopUpPoint){
                this.addTeacheDidiPoint(value.classID, 2)
            }
        }
    }
}
</script>
<style lang="scss" scoped >
.didi-dialog{
    .custom-icon{
        img{
            height: 30px;
        }
    }
    .text-center{
        text-align: center;
    }
    .confirm-button{
        height: 36px !important;
        padding: 0 !important;
        border-radius: 5px;
        color: #fff;
        width: 130px;
        box-shadow: none;
    }
}

</style>